import { render, staticRenderFns } from "./trainingModulePageNew14.vue?vue&type=template&id=65e6046a&scoped=true&"
import script from "./trainingModulePageNew14.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageNew14.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageNew14.vue?vue&type=style&index=0&id=65e6046a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e6046a",
  null
  
)

export default component.exports